import React, { useState } from 'react';
import { Modal, Accordion, Card } from 'react-bootstrap'
import { FaInfoCircle, FaDoorOpen } from "react-icons/fa";
import { InfoDiv, ActiveButton } from './styled/buttonlinkstyled'

function InfoLink() {
    // InfoLink開關設定
    const [tip, setTip] = useState(false);

    // 口罩實名制及販售相關文宣
    const getmask01 = 'https://upload.cc/i1/2020/03/08/wH0dfn.png'
    const getmask02 = 'https://upload.cc/i1/2020/02/13/ezMb8q.jpg'
    const getmask03 = 'https://upload.cc/i1/2020/02/13/GQbqsX.png'
    const getmask04 = 'https://upload.cc/i1/2020/02/13/pHyr2S.png'
    const getmask05 = 'https://upload.cc/i1/2020/02/13/Qk97CP.jpg'
    const getmask06 = 'https://upload.cc/i1/2020/02/13/DjV8Rs.png'

    // 口罩使用時機及使用場合相關文宣
    const wearmask01 = 'https://upload.cc/i1/2020/02/13/2CmIvj.jpg'
    const wearmask02 = 'https://upload.cc/i1/2020/02/13/Q7NpVH.jpg'
    const wearmask03 = 'https://upload.cc/i1/2020/02/13/3I24lU.jpg'
    const wearmask04 = 'https://upload.cc/i1/2020/02/13/Vzs9fM.jpg'
    const wearmask05 = 'https://upload.cc/i1/2020/02/13/nXs3Wq.png'

    // 口罩資訊及其他訊息相關文宣
    const maskinfo01 = 'https://upload.cc/i1/2020/02/13/g7ET5G.jpg'
    const maskinfo02 = 'https://upload.cc/i1/2020/02/13/RAqzbE.jpg'
    const maskinfo03 = 'https://upload.cc/i1/2020/02/13/KCEcH2.png'

    // InfoLink開關function
    function clickTip() {
        setTip(!tip);
    }

    return (
        <>
            {/* 這是InfoLink開關按鈕 */}
            <InfoDiv tip={tip} onClick={clickTip}>
                <FaInfoCircle />
            </InfoDiv>

            {/* 這是InfoLink的內容Modal */}
            <Modal
                show={tip}
                onHide={clickTip}
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title className='useTitle'>找口罩地圖─相關文宣宣導</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Accordion defaultActiveKey="3" className='textJhengHei'>
                        <Card>
                            <Accordion.Toggle as={Card.Header} className='useArticle useBgCustom' eventKey="0">
                                口罩實名制及販售相關文宣
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="0">
                                <Card.Body className='useBgGray useImage'>
                                    <img className='imageStyle' src={getmask01} alt='' />
                                    <img className='imageStyle' src={getmask02} alt='' />
                                    <img className='imageStyle' src={getmask03} alt='' />
                                    <img className='imageStyle' src={getmask04} alt='' />
                                    <img className='imageStyle' src={getmask05} alt='' />
                                    <img className='imageStyle' src={getmask06} alt='' />
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card>
                            <Accordion.Toggle as={Card.Header} className='useArticle' eventKey="1">
                                口罩使用時機及使用場合相關文宣
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="1">
                                <Card.Body className='useBgGray useImage'>
                                    <img className='imageStyle' src={wearmask01} alt='' />
                                    <img className='imageStyle' src={wearmask02} alt='' />
                                    <img className='imageStyle' src={wearmask03} alt='' />
                                    <img className='imageStyle' src={wearmask04} alt='' />
                                    <img className='imageStyle' src={wearmask05} alt='' />
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card>
                            <Accordion.Toggle as={Card.Header} className='useArticle' eventKey="2">
                                口罩資訊及其他訊息相關文宣
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="2">
                                <Card.Body className='useBgGray useContext'>
                                    <img className='imageStyle' src={maskinfo01} alt='' />
                                    <img className='imageStyle' src={maskinfo02} alt='' />
                                    <img className='imageStyle' src={maskinfo03} alt='' />
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card>
                            <Accordion.Toggle as={Card.Header} className='useArticle' eventKey="3">
                                關於網站
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="3">
                                <Card.Body className='useBgGray useContext'>
                                    <ul>
                                        <li>網站名稱：找口罩地圖</li>
                                        <li>網站版本：reactmaskmap v1.0</li>
                                        <li>網站製作：marcus</li>
                                        <li>聯絡方式： <a href="mailto:l46981105@gs.ncku.edu.tw" alt=''>【點我寄信】<br /></a></li>
                                        <li>補充事項：感謝Jason.C、花大、cici、地調所圖書室同事建議及協助測試</li>
                                    </ul>

                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                </Modal.Body>
                <Modal.Footer>
                    <ActiveButton onClick={clickTip}><FaDoorOpen />離開
                    </ActiveButton>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default InfoLink;